// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sales-print-template {
    display:none;
}
.sales-print-template-show {
    display:block !important;
}
.a5-print-container {
    overflow-x: auto;
    overflow-y: clip;
}
.a5-page-container {
    margin: 20px auto;
    border: 1px solid;
    width: 160mm !important;
    height: 210mm !important;
}
@media print {
    /*@page {*/
    /*  size: A5;*/
    /*  margin: 0;*/
    /*}*/
    header, footer {
        display: none !important;
    }
    body,
    html {
        -webkit-font-smoothing: none;
        width: 100% !important;
        height: 100% !important;
        /*height: 99% !important;*/
        padding: 0 !important;
        margin: 0 !important;
    }
    .a5-print-container {
        margin: 0 !important;
        /*padding: 0 10px !important;*/
        overflow-y: unset;
        overflow-x: unset;
    }
    .a5-page-container {
        width: auto !important;
        border: 0 !important;
        margin: 0 auto !important;
    }
    .sales-print-template {
        display: unset;
    }
    .page-break {
        page-break-after: always !important;
        page-break-inside: avoid !important;
    }
}
.a5-receipt {
    width: 148mm !important;
    height: 210mm !important;
    margin: auto;
    border: initial;
    border-radius: initial;
    box-shadow: initial;
    background: initial;
    padding: 0;
    font-family: "Arial", serif;
    position: relative !important;
}
.a5-invoice-box {
    font-size: 10px;
    color: #555;
    /* padding-bottom: 40px; */
}

.a5-paging {
    position: absolute;
    bottom: 2px;
    right: 0;
}

.a5-product-qr-code-img{
    border: 1px solid black;
    border-radius: 8px;
    padding: 6px;
    margin: 5px auto;
    display: block;
    width: 100px;
    height: 100px;
}
/* ------------------totals------------------ */

.a5-total_container {
    border: 1px solid transparent;
    border-radius: 12px;
    overflow: hidden;
    top: 0;
    right: 6px;
    /* margin-right: 6px; */
}

.a5-total_container > .a5-totals {

    border: 1px solid #ddd;
    /*box-shadow: 0 0 10px rgba(0, 0, 0, .15);*/
    font-size: 4px;
    background-color: #555;
}

.a5-total_container > .a5-totals p {
    padding: 4px;
    margin: 4px;
    font-size: 12px;
}

.a5-totals_table {
    border-spacing: 0;
    border-collapse: collapse;
    border: 0;
}

.a5-totals_table tr {
    padding: 16px;
    border: none;
    line-height: 0.8;
}

.a5-totals_table td {
    border: none;
}

.a5-totalpayment {
    font-weight: 700;
    font-size: 16px;
}

/* ------------------end totals------------------ */

.a5-invoice-box table {
    width: 100%;
    text-align: left;

}

.a5-invoice-box table td {
    padding: 1px;
}


.a5-invoice-box table tr.top table td.logo_container {
    font-size: 30px;
    width: 30%;
    color: #333
}

.a5-invoice-box table tr.information table td {
    padding-bottom: 40px
}

.a5-main_info_table tr {
    border: 1px solid #ddd;
    font-weight: 700;
    text-align: center;
}

.a5-invoice-box table tr.details td {
    padding-bottom: 20px
}

.a5-invoice-box table tr.item td {
    border-bottom: 1px solid #eee
}

.a5-invoice-box table tr.item.last td {
    border-bottom: none
}

.a5-invoice-box table tr.total td:nth-child(2) {
    border-top: 2px solid #eee;
    font-weight: 700
}

.a5-products {
    border: 1px solid #eee;
    text-align: center;
}

.a5-products p {
    height: 40px;
    font-size: 10px;
    margin: 4px;
}

.a5-product_table .a5-products td {
    font-size: 10px;
    text-align: center;
    border-right: 1px solid #ddd;
    height: 21px;
}

.a5-products td:has(.a5-item_description) {
    line-height: 1;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-clamp: 2;
}

.a5-product_table .a5-heading td {
    font-size: 10px;
    text-align: center;
    border-right: 1px solid #ddd;
    padding: 2px;
}

.a5-product_table .a5-heading p {
    margin: 0;
}

.a5-product_container {
    margin-top: 2px;
    border: 2px solid #555;
    border-radius: 4px;
    overflow: hidden;
    height: 234px;
}

.a5-rtl table {
    text-align: right
}

.a5-rtl table tr td:nth-child(2) {
    text-align: left
}

.a5-sender_sign {
    margin: 1px;
}

.a5-send_sign_container {
    margin: 0;
}

.a5-mydata_sign {
    /*position: absolute;*/
    /*bottom: 0;*/
    /*left: 0;*/
}

.a5-heading {
    background-color: #555;
    color: white;
}

.a5-main_info_table .a5-heading > td {
    line-height: 0;
}

.a5-information {

    border: 1px solid #555;
    border-radius: 4px;
    padding: 2px;

}

.a5-main_info {

    border: 1px solid #555;
    border-radius: 4px;
    overflow: hidden;

}

.a5-skin {
    color: #555;
}

.a5-bold {
    color: #555;
    font-weight: bold;
}

.a5-footer_container {
    margin-top: 5px;
    /* border: 1px solid #ddd; */
    width: 100%;
}


.a5-header_table td {
    border: none;

}

.a5-issuer_container {
    text-align: center;
}

.a5-issuer_container .a5-issuer_name {
    font-size: 12px;
    font-weight: bold;
}

.a5-issuer_container .a5-issuer_subjectField {
    font-style: italic;
}

.a5-issuer_container p {
    margin: 0;
    font-size: 10px;
}

.a5-gemh_issuer_p {
    font-style: italic;
}

.a5-information_table {
    margin-top: 2px;

}

.a5-information_table td {
    padding: 0;
    border: none;
    font-size: 8px;
}

.a5-code_head_td {
    width: 10%;
}

.a5-description_head_td {
    width: 36%;
}

.a5-price_head_td {
    width: 8%;
}

.a5-vat_head_td {
    width: 8%;
}

.a5-blank_row.bordered td {
    border-top: 1px solid white;
    background-color: white;
    max-height: 2px;
    height: 2px;
    line-height: 2px;
}

.a5-text-right {
    text-align: right;
    margin-right: 20px;
    background-color: white;
}

.a5-text-left {
    background-color: #555;
    color: white;
}

.a5-info_value {
    font-weight: bold;
}

.a5-cont_notation {
    border: 1px solid #555;
    padding: 8px;
    border-radius: 8px;
    overflow: hidden;
    overflow-wrap: break-word;
    margin-top: 2px;
}
.a5-vat_total_td {
    vertical-align: bottom;
    max-width: 250px;
}
.a5-per_vat_totals_container {
    border: 1px solid #555;
    border-radius: 8px;
    margin-top: 2px;
    vertical-align: bottom;
}

.a5-cont_signs {
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
}
.a5-total_td_block {
    vertical-align: bottom;
}
.a5-totals_table tr {
    padding: 10px;
}

.a5-footer_table {
    max-height:180px;
}

.a5-totals_per_vat th {
    color: #555;
    font-weight: bold;
}

.a5-total_funny_box {
    width: 80px;
    height: 46px;
    background-color: #555;
    border: 1px solid white;
    border-radius: 0 0 8px 0;
    position: absolute;
    bottom: 60px;
    right: -2px;
    z-index: -1;
    display: none;
}

.a5-union_doc_sign {
    position: absolute;
    transform: rotate(-90deg);
    left: -164px;
    bottom: 560px;
    font-size: 11px;
    margin: 0;

}

.a5-count_totals_container {
    padding: 4px;
    border: 4px solid #555;
    border-radius: 8px;
    min-height: 16px;
    overflow: hidden;
    margin-bottom: 4px;
}

.a5-count_total_prods {
    font-size: 16px;
    font-weight: bold;
}

.a5-cont_sign_left {
    float: left;
    text-align: center;
    width: 50%;
    font-size: 12px;
}

.a5-cont_sign_right {
    float: right;
    text-align: center;
    width: 50%;
    font-size: 12px;
}

.a5-fullname_sign {
    font-size: 9px;
}

.a5-sign_hr {
    margin: 0;
    width: 80%;
    margin-left: 10%
}

.a5-finalprice p {
    font-weight: bold;
    font-size: 16px !important;
}

.a5-information_td_left {
    width: 100%;
    font-size: 8px;
}

.a5-information_td_middle {
    vertical-align: bottom;
}

.a5-information_td_right {
    /* width: 46%; */
    max-height: 60px;
}

.a5-up_head_td p {
    font-size: 7px;
}

.a5-whtax_head_td p {
    font-size: 7px;
    word-break: keep-all;
}

.a5-pricenovat_head_td p {
    font-size: 7px;
}
.a5-text-head{
    font-size: 10px !important;
    text-decoration: underline;
}
.a5-information_customer_td{
    width:30%;
}
.a5-cancel {
    position: absolute;
    transform: translate(90px, -30%) rotate(-45deg);
    left:-30px;
    bottom: 50%;
    font-size: 150px;
    margin: 0 0 -200px 0;
    color: #cdcdcd;
    text-transform: uppercase;
    opacity: 0.7;
}
.a5-p {
    height: 16px;
    font-size: 10px;
    margin: 4px;
}
.bottom-container {
    vertical-align: bottom;
    line-height: 1.2;
}
.transactionDetailsTable:not(:last-child) {
    border-bottom: 1px solid grey;
}
.transactionDetailsTable tbody tr {
    height: 10px;
}
.transactionDetailsTable tbody tr td {
    height: 10px;
}
.transactionDetailsTable tbody tr td:nth-child(1) {
    text-align: left;
}
.transactionDetailsTable tbody tr td:nth-child(2) {
    text-align: right;
}
.page-break {
    page-break-after: always !important;
    page-break-inside: avoid !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/InvoicePrint/invoicePrint-a5.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;AAC5B;AACA;IACI,UAAU;IACV,cAAc;IACd,eAAe;IACf,IAAI;IACJ;QACI,wBAAwB;IAC5B;IACA;;QAEI,4BAA4B;QAC5B,sBAAsB;QACtB,uBAAuB;QACvB,0BAA0B;QAC1B,qBAAqB;QACrB,oBAAoB;IACxB;IACA;QACI,oBAAoB;QACpB,8BAA8B;QAC9B,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,yBAAyB;IAC7B;IACA;QACI,cAAc;IAClB;IACA;QACI,mCAAmC;QACnC,mCAAmC;IACvC;AACJ;AACA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,2BAA2B;IAC3B,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,aAAa;AACjB;AACA,+CAA+C;;AAE/C;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,uBAAuB;AAC3B;;AAEA;;IAEI,sBAAsB;IACtB,2CAA2C;IAC3C,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,mDAAmD;;AAEnD;IACI,WAAW;IACX,gBAAgB;;AAEpB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,eAAe;IACf,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;;AAEhB;;AAEA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,WAAW;AACf;;;AAGA;IACI,YAAY;;AAEhB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,SAAS;;AAEb;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;AACA;IACI,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,mCAAmC;IACnC,mCAAmC;AACvC","sourcesContent":[".sales-print-template {\r\n    display:none;\r\n}\r\n.sales-print-template-show {\r\n    display:block !important;\r\n}\r\n.a5-print-container {\r\n    overflow-x: auto;\r\n    overflow-y: clip;\r\n}\r\n.a5-page-container {\r\n    margin: 20px auto;\r\n    border: 1px solid;\r\n    width: 160mm !important;\r\n    height: 210mm !important;\r\n}\r\n@media print {\r\n    /*@page {*/\r\n    /*  size: A5;*/\r\n    /*  margin: 0;*/\r\n    /*}*/\r\n    header, footer {\r\n        display: none !important;\r\n    }\r\n    body,\r\n    html {\r\n        -webkit-font-smoothing: none;\r\n        width: 100% !important;\r\n        height: 100% !important;\r\n        /*height: 99% !important;*/\r\n        padding: 0 !important;\r\n        margin: 0 !important;\r\n    }\r\n    .a5-print-container {\r\n        margin: 0 !important;\r\n        /*padding: 0 10px !important;*/\r\n        overflow-y: unset;\r\n        overflow-x: unset;\r\n    }\r\n    .a5-page-container {\r\n        width: auto !important;\r\n        border: 0 !important;\r\n        margin: 0 auto !important;\r\n    }\r\n    .sales-print-template {\r\n        display: unset;\r\n    }\r\n    .page-break {\r\n        page-break-after: always !important;\r\n        page-break-inside: avoid !important;\r\n    }\r\n}\r\n.a5-receipt {\r\n    width: 148mm !important;\r\n    height: 210mm !important;\r\n    margin: auto;\r\n    border: initial;\r\n    border-radius: initial;\r\n    box-shadow: initial;\r\n    background: initial;\r\n    padding: 0;\r\n    font-family: \"Arial\", serif;\r\n    position: relative !important;\r\n}\r\n.a5-invoice-box {\r\n    font-size: 10px;\r\n    color: #555;\r\n    /* padding-bottom: 40px; */\r\n}\r\n\r\n.a5-paging {\r\n    position: absolute;\r\n    bottom: 2px;\r\n    right: 0;\r\n}\r\n\r\n.a5-product-qr-code-img{\r\n    border: 1px solid black;\r\n    border-radius: 8px;\r\n    padding: 6px;\r\n    margin: 5px auto;\r\n    display: block;\r\n    width: 100px;\r\n    height: 100px;\r\n}\r\n/* ------------------totals------------------ */\r\n\r\n.a5-total_container {\r\n    border: 1px solid transparent;\r\n    border-radius: 12px;\r\n    overflow: hidden;\r\n    top: 0;\r\n    right: 6px;\r\n    /* margin-right: 6px; */\r\n}\r\n\r\n.a5-total_container > .a5-totals {\r\n\r\n    border: 1px solid #ddd;\r\n    /*box-shadow: 0 0 10px rgba(0, 0, 0, .15);*/\r\n    font-size: 4px;\r\n    background-color: #555;\r\n}\r\n\r\n.a5-total_container > .a5-totals p {\r\n    padding: 4px;\r\n    margin: 4px;\r\n    font-size: 12px;\r\n}\r\n\r\n.a5-totals_table {\r\n    border-spacing: 0;\r\n    border-collapse: collapse;\r\n    border: 0;\r\n}\r\n\r\n.a5-totals_table tr {\r\n    padding: 16px;\r\n    border: none;\r\n    line-height: 0.8;\r\n}\r\n\r\n.a5-totals_table td {\r\n    border: none;\r\n}\r\n\r\n.a5-totalpayment {\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n}\r\n\r\n/* ------------------end totals------------------ */\r\n\r\n.a5-invoice-box table {\r\n    width: 100%;\r\n    text-align: left;\r\n\r\n}\r\n\r\n.a5-invoice-box table td {\r\n    padding: 1px;\r\n}\r\n\r\n\r\n.a5-invoice-box table tr.top table td.logo_container {\r\n    font-size: 30px;\r\n    width: 30%;\r\n    color: #333\r\n}\r\n\r\n.a5-invoice-box table tr.information table td {\r\n    padding-bottom: 40px\r\n}\r\n\r\n.a5-main_info_table tr {\r\n    border: 1px solid #ddd;\r\n    font-weight: 700;\r\n    text-align: center;\r\n}\r\n\r\n.a5-invoice-box table tr.details td {\r\n    padding-bottom: 20px\r\n}\r\n\r\n.a5-invoice-box table tr.item td {\r\n    border-bottom: 1px solid #eee\r\n}\r\n\r\n.a5-invoice-box table tr.item.last td {\r\n    border-bottom: none\r\n}\r\n\r\n.a5-invoice-box table tr.total td:nth-child(2) {\r\n    border-top: 2px solid #eee;\r\n    font-weight: 700\r\n}\r\n\r\n.a5-products {\r\n    border: 1px solid #eee;\r\n    text-align: center;\r\n}\r\n\r\n.a5-products p {\r\n    height: 40px;\r\n    font-size: 10px;\r\n    margin: 4px;\r\n}\r\n\r\n.a5-product_table .a5-products td {\r\n    font-size: 10px;\r\n    text-align: center;\r\n    border-right: 1px solid #ddd;\r\n    height: 21px;\r\n}\r\n\r\n.a5-products td:has(.a5-item_description) {\r\n    line-height: 1;\r\n    overflow: hidden;\r\n    word-break: break-all;\r\n    text-overflow: ellipsis;\r\n    display: -webkit-box;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-line-clamp: 2;\r\n    line-clamp: 2;\r\n}\r\n\r\n.a5-product_table .a5-heading td {\r\n    font-size: 10px;\r\n    text-align: center;\r\n    border-right: 1px solid #ddd;\r\n    padding: 2px;\r\n}\r\n\r\n.a5-product_table .a5-heading p {\r\n    margin: 0;\r\n}\r\n\r\n.a5-product_container {\r\n    margin-top: 2px;\r\n    border: 2px solid #555;\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n    height: 234px;\r\n}\r\n\r\n.a5-rtl table {\r\n    text-align: right\r\n}\r\n\r\n.a5-rtl table tr td:nth-child(2) {\r\n    text-align: left\r\n}\r\n\r\n.a5-sender_sign {\r\n    margin: 1px;\r\n}\r\n\r\n.a5-send_sign_container {\r\n    margin: 0;\r\n}\r\n\r\n.a5-mydata_sign {\r\n    /*position: absolute;*/\r\n    /*bottom: 0;*/\r\n    /*left: 0;*/\r\n}\r\n\r\n.a5-heading {\r\n    background-color: #555;\r\n    color: white;\r\n}\r\n\r\n.a5-main_info_table .a5-heading > td {\r\n    line-height: 0;\r\n}\r\n\r\n.a5-information {\r\n\r\n    border: 1px solid #555;\r\n    border-radius: 4px;\r\n    padding: 2px;\r\n\r\n}\r\n\r\n.a5-main_info {\r\n\r\n    border: 1px solid #555;\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n\r\n}\r\n\r\n.a5-skin {\r\n    color: #555;\r\n}\r\n\r\n.a5-bold {\r\n    color: #555;\r\n    font-weight: bold;\r\n}\r\n\r\n.a5-footer_container {\r\n    margin-top: 5px;\r\n    /* border: 1px solid #ddd; */\r\n    width: 100%;\r\n}\r\n\r\n\r\n.a5-header_table td {\r\n    border: none;\r\n\r\n}\r\n\r\n.a5-issuer_container {\r\n    text-align: center;\r\n}\r\n\r\n.a5-issuer_container .a5-issuer_name {\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n}\r\n\r\n.a5-issuer_container .a5-issuer_subjectField {\r\n    font-style: italic;\r\n}\r\n\r\n.a5-issuer_container p {\r\n    margin: 0;\r\n    font-size: 10px;\r\n}\r\n\r\n.a5-gemh_issuer_p {\r\n    font-style: italic;\r\n}\r\n\r\n.a5-information_table {\r\n    margin-top: 2px;\r\n\r\n}\r\n\r\n.a5-information_table td {\r\n    padding: 0;\r\n    border: none;\r\n    font-size: 8px;\r\n}\r\n\r\n.a5-code_head_td {\r\n    width: 10%;\r\n}\r\n\r\n.a5-description_head_td {\r\n    width: 36%;\r\n}\r\n\r\n.a5-price_head_td {\r\n    width: 8%;\r\n}\r\n\r\n.a5-vat_head_td {\r\n    width: 8%;\r\n}\r\n\r\n.a5-blank_row.bordered td {\r\n    border-top: 1px solid white;\r\n    background-color: white;\r\n    max-height: 2px;\r\n    height: 2px;\r\n    line-height: 2px;\r\n}\r\n\r\n.a5-text-right {\r\n    text-align: right;\r\n    margin-right: 20px;\r\n    background-color: white;\r\n}\r\n\r\n.a5-text-left {\r\n    background-color: #555;\r\n    color: white;\r\n}\r\n\r\n.a5-info_value {\r\n    font-weight: bold;\r\n}\r\n\r\n.a5-cont_notation {\r\n    border: 1px solid #555;\r\n    padding: 8px;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    overflow-wrap: break-word;\r\n    margin-top: 2px;\r\n}\r\n.a5-vat_total_td {\r\n    vertical-align: bottom;\r\n    max-width: 250px;\r\n}\r\n.a5-per_vat_totals_container {\r\n    border: 1px solid #555;\r\n    border-radius: 8px;\r\n    margin-top: 2px;\r\n    vertical-align: bottom;\r\n}\r\n\r\n.a5-cont_signs {\r\n    overflow: hidden;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n.a5-total_td_block {\r\n    vertical-align: bottom;\r\n}\r\n.a5-totals_table tr {\r\n    padding: 10px;\r\n}\r\n\r\n.a5-footer_table {\r\n    max-height:180px;\r\n}\r\n\r\n.a5-totals_per_vat th {\r\n    color: #555;\r\n    font-weight: bold;\r\n}\r\n\r\n.a5-total_funny_box {\r\n    width: 80px;\r\n    height: 46px;\r\n    background-color: #555;\r\n    border: 1px solid white;\r\n    border-radius: 0 0 8px 0;\r\n    position: absolute;\r\n    bottom: 60px;\r\n    right: -2px;\r\n    z-index: -1;\r\n    display: none;\r\n}\r\n\r\n.a5-union_doc_sign {\r\n    position: absolute;\r\n    transform: rotate(-90deg);\r\n    left: -164px;\r\n    bottom: 560px;\r\n    font-size: 11px;\r\n    margin: 0;\r\n\r\n}\r\n\r\n.a5-count_totals_container {\r\n    padding: 4px;\r\n    border: 4px solid #555;\r\n    border-radius: 8px;\r\n    min-height: 16px;\r\n    overflow: hidden;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.a5-count_total_prods {\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n}\r\n\r\n.a5-cont_sign_left {\r\n    float: left;\r\n    text-align: center;\r\n    width: 50%;\r\n    font-size: 12px;\r\n}\r\n\r\n.a5-cont_sign_right {\r\n    float: right;\r\n    text-align: center;\r\n    width: 50%;\r\n    font-size: 12px;\r\n}\r\n\r\n.a5-fullname_sign {\r\n    font-size: 9px;\r\n}\r\n\r\n.a5-sign_hr {\r\n    margin: 0;\r\n    width: 80%;\r\n    margin-left: 10%\r\n}\r\n\r\n.a5-finalprice p {\r\n    font-weight: bold;\r\n    font-size: 16px !important;\r\n}\r\n\r\n.a5-information_td_left {\r\n    width: 100%;\r\n    font-size: 8px;\r\n}\r\n\r\n.a5-information_td_middle {\r\n    vertical-align: bottom;\r\n}\r\n\r\n.a5-information_td_right {\r\n    /* width: 46%; */\r\n    max-height: 60px;\r\n}\r\n\r\n.a5-up_head_td p {\r\n    font-size: 7px;\r\n}\r\n\r\n.a5-whtax_head_td p {\r\n    font-size: 7px;\r\n    word-break: keep-all;\r\n}\r\n\r\n.a5-pricenovat_head_td p {\r\n    font-size: 7px;\r\n}\r\n.a5-text-head{\r\n    font-size: 10px !important;\r\n    text-decoration: underline;\r\n}\r\n.a5-information_customer_td{\r\n    width:30%;\r\n}\r\n.a5-cancel {\r\n    position: absolute;\r\n    transform: translate(90px, -30%) rotate(-45deg);\r\n    left:-30px;\r\n    bottom: 50%;\r\n    font-size: 150px;\r\n    margin: 0 0 -200px 0;\r\n    color: #cdcdcd;\r\n    text-transform: uppercase;\r\n    opacity: 0.7;\r\n}\r\n.a5-p {\r\n    height: 16px;\r\n    font-size: 10px;\r\n    margin: 4px;\r\n}\r\n.bottom-container {\r\n    vertical-align: bottom;\r\n    line-height: 1.2;\r\n}\r\n.transactionDetailsTable:not(:last-child) {\r\n    border-bottom: 1px solid grey;\r\n}\r\n.transactionDetailsTable tbody tr {\r\n    height: 10px;\r\n}\r\n.transactionDetailsTable tbody tr td {\r\n    height: 10px;\r\n}\r\n.transactionDetailsTable tbody tr td:nth-child(1) {\r\n    text-align: left;\r\n}\r\n.transactionDetailsTable tbody tr td:nth-child(2) {\r\n    text-align: right;\r\n}\r\n.page-break {\r\n    page-break-after: always !important;\r\n    page-break-inside: avoid !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
